import { ApiCall } from "../../api";
import { BASE_URL, authToken } from "../../constants/const";
import {
    GET_HOME_CARDS,
    LEFT_SWIPE,
    RIGHT_SWIPE,
    GET_REQUEST_LIST,
    UPDATE_LAT_LONG,
    DELETE_MY_CONNECTION
} from "../constants";

export const getHomeConnection = (data, successCb = null, failureCb = null) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { Authorization: `Bearer ${authToken}` },
    url: `${BASE_URL}users/get_home_connections`,
    data,
  };
  let response = await ApiCall(config, dispatch);
  if (successCb && response?.data?.status) {
    successCb(response?.data);
  } else if(failureCb){
    failureCb(response?.data)
  }
  dispatch({
    type: GET_HOME_CARDS,
    payload: response?.data,
  });
};

export const leftSwip = (successCb, data) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { Authorization: `Bearer ${authToken}` },
    url: `${BASE_URL}users/left_swipe`, 
    data,
  };
  let response = await ApiCall(config, dispatch);
  if (response.data.status) {
    successCb(response?.data);
  }
  dispatch({
    type: LEFT_SWIPE,
    payload: response?.data,
  });
};

export const rightSwip = (successCb, data) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { Authorization: `Bearer ${authToken}` },
    url: `${BASE_URL}users/right_swipe`,
    data,
  };
  let response = await ApiCall(config, dispatch);
  if (response?.data?.status) {
    successCb(response?.data);
  }
  dispatch({
    type: RIGHT_SWIPE,
    payload: response?.data,
  });
};

export const updateLatLong = (token) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { Authorization: `Bearer ${token || ""}` },
    url: `${BASE_URL}users/update_user_location`,
  };
  let response = await ApiCall(config, dispatch);
  dispatch({
    type: UPDATE_LAT_LONG,
    payload: response?.data,
  });
};

// Pending Request (Dating) API ---> Done
export const getRequestList = (token) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { Authorization: `Bearer ${token}` },
    url: `${BASE_URL}users/get_request_list`,
  };
  let response = await ApiCall(config, dispatch);
  dispatch({
    type: GET_REQUEST_LIST,
    payload: response?.data,
  });
};

// Dating Connection API
export const deleteMyConnection = (token, data, successCb) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { Authorization: `Bearer ${token}` },
    url: `${BASE_URL}users/delete_my_connection`,
    data,
  };
  let response = await ApiCall(config, dispatch);
  if (response.data.status) {
    successCb(response.data);
  }
  dispatch({
    type: DELETE_MY_CONNECTION,
    payload: response?.data,
  });
};
